// removed by extract-text-webpack-plugin
module.exports = {"searchContainer":"searchContainer--1Kgp0","focused":"focused--mfS7w"};